/** 银川中心点（WGS84）—— 光锥锚点，科技特效以此为中心 */
export const CENTER = {
  lng: 106.226152,
  lat: 38.485145,
};

/** 相对中心点的矩形 [west, south, east, north]（度） */
export function offsetRect(dWest, dSouth, dEast, dNorth) {
  return [
    CENTER.lng + dWest,
    CENTER.lat + dSouth,
    CENTER.lng + dEast,
    CENTER.lat + dNorth,
  ];
}

/** 以中心为对称的矩形半宽半高（度） */
export function centerRect(halfLng, halfLat = halfLng) {
  return offsetRect(-halfLng, -halfLat, halfLng, halfLat);
}

export function offsetLonLat(dLng, dLat, height = 0) {
  return [CENTER.lng + dLng, CENTER.lat + dLat, height];
}
